module.exports = __webpack_public_path__ + "static/media/RoundedRect_Grey.8e1c1c33.png";